export const environment = {
  production: false,
  apiUrl: 'https://apitest.vizeasist.com/api',
  uploadsUrl: 'https://cdntest.vizeasist.com',
  featureFlag: true,
};
